import * as actions from './actions'
import { selectors } from './selectors'

export const calcLogics = { actions, selectors }
